export default __webpack_public_path__ + "static/media/SmartShopping_logo_horizontal_color.0caccdb3.svg";